(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('TicketDetailController', TicketDetailController);

    TicketDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ticket', 'Item', 'Zeta'];

    function TicketDetailController($scope, $rootScope, $stateParams, previousState, entity, Ticket, Item, Zeta) {
        var vm = this;

        vm.ticket = entity;
        vm.previousState = previousState.name;
		vm.items = [];
        loadAll();

        function loadAll() {
            Item.queryByTicket({id: vm.ticket.id}, function(result) {
                vm.items = result;
                vm.searchQuery = null;
            });
        } 

        var unsubscribe = $rootScope.$on('mVtasWebApp:ticketUpdate', function(event, result) {
            vm.ticket = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
